// Phase 25 iter-5b — KYC client (DIDIT).
//
// O backend xa expón:
//   GET  /api/v1/kyc/status   → KycStatusResponse
//   POST /api/v1/kyc/session  → KycSessionResponse (URL de DIDIT)
// O webhook procesase server-side e actualiza User.kyc_status.

import {
  API_VERSION_PREFIX,
  type KycSessionResponse,
  type KycStatusResponse,
} from '@leyrochain/shared';

import { apiClient } from './client';

export async function fetchKycStatus(): Promise<KycStatusResponse> {
  const { data } = await apiClient.get<KycStatusResponse>(`${API_VERSION_PREFIX}/kyc/status`);
  return data;
}

export async function startKycSession(): Promise<KycSessionResponse> {
  const { data } = await apiClient.post<KycSessionResponse>(`${API_VERSION_PREFIX}/kyc/session`);
  return data;
}
